import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { name: '首页', path: '/' },
      { name: '赛事中心', path: '/category/all' },
      { name: '新闻资讯', path: '/category/news' },
      { name: '关于我们', path: '/about' },
    ],
  },
  {
    title: '热门赛事',
    links: [
      { name: '英雄联盟', path: '/category/lol' },
      { name: 'CS2', path: '/category/cs2' },
      { name: 'DOTA2', path: '/category/dota2' },
      { name: '王者荣耀', path: '/category/hok' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '平台信誉', path: '/about' },
      { name: '联系我们', path: '/about' },
      { name: '用户协议', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-bold whitespace-nowrap">
              开云电竞
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              开云电竞是面向电竞爱好者的专业竞技平台，提供丰富的电竞赛事资讯、实时数据与深度分析服务。加入我们，体验顶级电竞内容。
            </p>
            <div className="flex items-center space-x-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold mb-4 text-background-50">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 开云电竞 版权所有 | 专业电竞竞技平台
          </p>
          <p className="text-xs text-foreground-500">
            电竞赛事投注 | 实时数据 | 安全稳定 | 注册便捷
          </p>
        </div>
      </div>
    </footer>
  );
}